import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "cn";

const typographyVariants = cva("text-text-dark-max", {
  variants: {
    size: {
      xs: "text-xs",
      sm: "text-sm",
      base: "text-base",
      lg: "text-lg",
      xl: "text-xl",
      "2xl": "text-2xl",
      "3xl": "text-3xl",
      "4xl": "text-4xl",
      "5xl": "text-5xl",
      "6xl": "text-6xl",
      "7xl": "text-7xl",
      "8xl": "text-8xl",
      "9xl": "text-9xl",
    },
  },
  defaultVariants: {
    size: "base",
  },
});

export function Typography({
  children,
  size,
  className,
  ...props
}: React.ComponentProps<"p"> & VariantProps<typeof typographyVariants>) {
  return (
    <p className={cn(typographyVariants({ size }), className)} {...props}>
      {children}
    </p>
  );
}
